<template>
  <!--Nav-->
  <nav id="header" class="w-full z-30 top-0 py-1 bg-gray-800 text-yellow-500">
    
    <div
      class="w-full container mx-auto flex flex-col justify-center items-center md:flex-row md:justify-between mt-0 px-6 py-3"
    >
 
        <nav class="order-2 md:order-1">
          <ul
            class="md:flex md:items-center md:justify-between text-base text-yellow-500 pt-4 md:pt-0"
          >
            <li>
              <a
                class="inline-block no-underline hover:text-yellow-400 hover:underline py-2 px-4"
                href="#about"
                >About the project</a
              >
            </li>
            <li>
              <a
                class="inline-block no-underline hover:text-yellow-400 hover:underline py-2 px-4"
                href="#theFirstCollection"
                >The first collection</a
              >
            </li>
          </ul>
        </nav>
  

      <div class="order-1 md:order-2">
        <a
          class="tracking-wide mx-auto no-underline hover:no-underline font-bold text-gray-800"
          href="#"
        >
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            height="4rem"
            width="8rem"
            viewBox="-453.5 -224.5 582.333 285.833"
            enable-background="new -453.5 -224.5 582.333 285.833"
            xml:space="preserve"
          >
            <g>
              <path
                fill="#ED6C30"
                d="M35.844-160.305c-4.916,1.069-9.158,3.811-11.143,8.541c-1.197,2.871-2.871,10.284-7.461,8.367
		c-2.197-0.907-2.16-4.056-1.906-6.019c0.547-4.032,2.361-7.716,3.602-11.551c1.281-3.974,2.383-7.972,3.174-12.085
		c2.648-13.619,1.918-29.306-7.717-40.195c-1.625-1.859-5.729-6.159-8.438-6.251c-1.672-0.046-0.021,1.929,0.443,2.591
		c0.941,1.359,1.732,2.835,2.336,4.381c7.123,18.174-10.436,32.014-21.975,42.786c-5.531,5.171-9.947,10.656-13.921,17.059
		c-0.396,0.616-1.267,2.685-2.394,2.255c-1.336-0.512-1.477-3.568-1.895-4.707c-0.791-2.185-2.01-4.566-3.579-6.275
		c-3.032-3.323-7.274-5.566-11.864-5.264c-0.174,0.011-0.674,0.092-1.29,0.232c-0.964,0.209-3.544,0.546-2.847,2.103
		c0.36,0.802,1.417,0.732,2.173,0.953c9.691,2.975,9.471,13.131,7.901,21.289c-2.835,14.85-10.69,28.887-5.112,44.157
		c6.577,18,27.168,29.237,45.854,26.146c5.1-0.838,10.98-2.487,15.559-4.949c4.871-2.627,10.203-6.219,14.004-10.261
		c4.891-5.195,8.006-11.853,8.924-18.907c1.08-8.157-1.523-15.85-3.893-23.554c-2.859-9.296-6.148-24.473,5.729-29.016
		c0.58-0.233,1.742-0.407,2.148-1.022C43.77-161.758,36.518-160.445,35.844-160.305z"
              />
              <path
                fill="#FCC21B"
                d="M0.447-96.498c2.465,2.068,5.918,1.058,8.242-0.709c1.24-0.941,2.311-2.15,3.008-3.555
		c0.291-0.605,0.627-1.372,0.627-2.058c0-0.918-0.547-1.824-0.313-2.766c1.951-0.383,4.369,5.229,4.611,6.531
		c1.955,10.261-7.715,18.72-17.047,20.359c-15.744,2.754-24.797-11.039-22.984-23.288c1.127-7.623,6.24-12.863,11.446-18.092
		c4.312-4.334,8.308-8.053,9.702-13.689c0.244-0.999,0.188-2.533-0.104-3.52c-0.244-0.849-0.709-1.627-0.732-2.545
		c-0.07-1.929,1.801,0.592,2.232,1.081c5.182,5.845,6.658,14.479,5.273,22.032c-0.895,4.881-4.381,8.367-5.6,13.039
		C-1.898-101.019-1.828-98.427,0.447-96.498z"
              />
            </g>
            <g>
              <path
                fill="#FFFFFF"
                d="M-355.729-60.786h53c8.833,0,15.614,2.188,20.344,6.563c4.729,4.375,7.094,9.792,7.094,16.25
		c0,5.417-1.688,10.063-5.063,13.938c-2.25,2.584-5.542,4.625-9.875,6.125c6.583,1.584,11.427,4.303,14.531,8.156
		c3.104,3.854,4.656,8.698,4.656,14.531c0,4.75-1.104,9.021-3.313,12.813c-2.209,3.792-5.229,6.792-9.063,9
		c-2.375,1.375-5.959,2.375-10.75,3c-6.375,0.834-10.604,1.25-12.688,1.25h-48.875V-60.786z M-327.166-24.848h12.313
		c4.416,0,7.489-0.76,9.219-2.281c1.729-1.521,2.594-3.719,2.594-6.594c0-2.666-0.865-4.75-2.594-6.25
		c-1.729-1.5-4.74-2.25-9.031-2.25h-12.5V-24.848z M-327.166,11.152h14.438c4.875,0,8.313-0.864,10.313-2.594
		c2-1.729,3-4.052,3-6.969c0-2.708-0.99-4.885-2.969-6.531c-1.979-1.646-5.448-2.469-10.406-2.469h-14.375V11.152z"
              />
              <path
                fill="#FFFFFF"
                d="M-199.916-60.786h28.25v54.589c0,5.413-0.844,10.524-2.531,15.333c-1.688,4.81-4.334,9.016-7.938,12.617
		c-3.604,3.602-7.386,6.131-11.344,7.588c-5.5,2.04-12.104,3.061-19.813,3.061c-4.459,0-9.323-0.313-14.594-0.937
		c-5.271-0.626-9.678-1.863-13.219-3.717c-3.542-1.853-6.781-4.486-9.719-7.9s-4.948-6.933-6.031-10.556
		c-1.75-5.829-2.625-10.992-2.625-15.489v-54.589h28.25v55.889c0,4.996,1.385,8.899,4.156,11.709
		c2.771,2.811,6.614,4.215,11.531,4.215c4.875,0,8.697-1.384,11.469-4.152c2.771-2.769,4.156-6.692,4.156-11.771V-60.786z"
              />
              <path
                fill="#FFFFFF"
                d="M-152.541,30.839v-91.625h47.188c8.75,0,15.438,0.75,20.063,2.25s8.354,4.281,11.188,8.344
		c2.833,4.063,4.25,9.011,4.25,14.844c0,5.084-1.084,9.469-3.252,13.156s-5.149,6.678-8.942,8.969
		c-2.418,1.459-5.732,2.667-9.943,3.625c3.372,1.127,5.829,2.253,7.37,3.378c1.041,0.751,2.55,2.356,4.528,4.817
		c1.978,2.461,3.3,4.358,3.966,5.692l13.711,26.55h-31.991l-15.134-28c-1.917-3.625-3.625-5.979-5.125-7.063
		c-2.042-1.416-4.354-2.125-6.938-2.125h-2.5v37.188H-152.541z M-124.104-23.661h11.938c1.291,0,3.791-0.416,7.5-1.25
		c1.875-0.375,3.406-1.333,4.594-2.875c1.188-1.541,1.781-3.313,1.781-5.313c0-2.958-0.938-5.229-2.813-6.813
		c-1.875-1.583-5.396-2.375-10.563-2.375h-12.438V-23.661z"
              />
              <path
                fill="#FFFFFF"
                d="M-53.166-60.786h26.438l34.5,50.691v-50.691h26.688v91.625H7.772l-34.313-50.309v50.309h-26.625V-60.786z"
              />
            </g>
            <g>
              <path
                fill="#FFFFFF"
                d="M-353.687-76.649l41.51-108.087h15.409l44.238,108.087h-16.294l-12.608-32.736h-45.196l-11.87,32.736
		H-353.687z M-322.499-121.035h36.644l-11.281-29.934c-3.441-9.093-5.997-16.563-7.667-22.414
		c-1.377,6.931-3.318,13.813-5.825,20.644L-322.499-121.035z"
              />
              <path
                fill="#FFFFFF"
                d="M-240.88-76.649v-108.087h47.924c9.633,0,16.958,0.971,21.972,2.913c5.013,1.942,9.019,5.371,12.018,10.285
		c2.998,4.916,4.498,10.347,4.498,16.294c0,7.668-2.482,14.132-7.447,19.391c-4.965,5.26-12.633,8.602-23.003,10.027
		c3.784,1.819,6.66,3.613,8.626,5.382c4.177,3.834,8.134,8.626,11.87,14.377l18.801,29.418h-17.99l-14.303-22.487
		c-4.178-6.488-7.62-11.453-10.322-14.894c-2.704-3.44-5.124-5.849-7.262-7.226c-2.138-1.375-4.313-2.334-6.525-2.875
		c-1.622-0.343-4.276-0.516-7.963-0.516h-16.589v47.998H-240.88z M-226.577-137.034h30.745c6.537,0,11.649-0.675,15.336-2.028
		c3.687-1.351,6.488-3.514,8.405-6.488c1.917-2.973,2.875-6.205,2.875-9.695c0-5.111-1.856-9.314-5.567-12.607
		c-3.712-3.292-9.573-4.94-17.584-4.94h-34.21V-137.034z"
              />
              <path
                fill="#FFFFFF"
                d="M-107.283-76.649v-95.332h-35.611v-12.755h85.673v12.755h-35.759v95.332H-107.283z"
              />
            </g>
            <g>
              <path
                fill="#FFFFFF"
                d="M-377.97-28.89v10.195h-64.525V-28.89H-377.97z M-379.367-112.829v10.057h-61.591v-10.057H-379.367z M-384.115-72.465v10.056h-52.234v-10.056H-384.115z"
              />
            </g>
            <g>
              <path
                fill="#FFFFFF"
                d="M129.996-28.89v10.195H65.471V-28.89H129.996z M128.599-112.828v10.057H67.008v-10.057H128.599z M123.85-72.465v10.056H71.616v-10.056H123.85z"
              />
            </g>
          </svg>
        </a>
      </div>
      <div class="order-3">

        <button v-if="!connected" @click="enableEthereum" class="bg-transparent hover:bg-indigo-300 text-indigo-400 font-semibold hover:text-white py-2 px-4 border border-indigo-300 hover:border-transparent rounded">
        Connect to Ethereum
        </button>
        <div class="text-xs" v-else>
          <span class="text-gray-600">Connected as</span><br />
          <span class="text-gray-400">{{this.account}}</span><br />
            <a
                class="inline-block no-underline hover:text-yellow-400 hover:underline py-2 px-4"
                href="#yourpieces"
                >You own {{tokenCount}} pieces</a
              >
        
        </div>

      </div>
 
    </div>
  </nav>
  
</template>

<script>
export default {
  name: "Nav",

  mounted(){
    if(this.account != undefined){
      this.connected = true;
    }
    this.emitter.on('ethereum-enabled', async (account) => {
      this.connected = true;
      this.tokenCount = await this.artburnDapp.methods
    .balanceOf(account)
    .call();
      });
  },
  data(){
    return {
      connected: false,
      tokenCount: 0
    }
  },
  methods:{
      async enableEthereum(){
        
        const accounts =  await this.web3Client.eth.currentProvider.request({ method: 'eth_requestAccounts' });
        this.emitter.emit('ethereum-enabled',accounts[0]);
  
      },
  }
};
</script>

